// import React from "react";
// import Card from "react-bootstrap/Card";
// import { ImPointRight } from "react-icons/im";

// export default function AboutCard() {
//   return (
//     <Card className="quote-card-view">
//       <Card.Body>
//         <blockquote className="blockquote mb-0">
//           <p style={{ textAlign: "justify" }}>
//             Hello Everyone, My name is <span className="purple">Asif Alam </span>
//             <br />
//             I am a Computer Engineering 2nd year student love to learn new technology and build products.
//             <br />
//             <br />
//             Apart from coding, some other activities that I love to do!
//           </p>
//           <ul>
//             <li className="about-activity">
//               <ImPointRight /> Playing chess
//             </li>
//             <li className="about-activity">
//               <ImPointRight /> Watching sci-fi web series
//             </li>
//             <li className="about-activity">
//               <ImPointRight /> Travelling
//             </li>
//           </ul>

//           <p style={{ color: "rgb(155 126 172)" }}>
//             "Enthusiastic to build things that make a difference!"{" "}
//           </p>
//           <footer className="blockquote-footer">Asif</footer>
//         </blockquote>
//       </Card.Body>
//     </Card>
//   );
// }

import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

export default function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hey Everyone
            <br />
            Picture a developer who can switch between Spring Boot, Node, and Flutter as easily as switching browser tabs - that's me! 
            I'm a <span className="purple">third-year Computer Engineering student</span> who believes in learning by doing, not just studying.
            <br />
            <br />
            My tech toolkit includes:
            <ul>
              <li><ImPointRight /> Java ecosystem (Spring, JDBC, Servlet, JSP) for robust backend solutions</li>
              <li><ImPointRight /> Flutter & React for crafting seamless user experiences</li>
              <li><ImPointRight /> AWS & Firebase for cloud-powered innovations</li>
              <li><ImPointRight /> Git/GitHub for collaborative development</li>
              <li><ImPointRight /> Strong DSA foundation for optimized solutions</li>
            </ul>
            Instead of reading about industry challenges in textbooks, I'm eager to tackle them head-on through an internship opportunity.
            Your experience in the tech world would be invaluable in helping me navigate this crucial step in my journey.
            <br />
            <br />
            Would you be open to a quick chat about potential opportunities in your network or organization? Your guidance could be the bridge between classroom theory and real-world impact.
            <br />
            <br />
            Ready to contribute and learn!
          </p>

          <p style={{ color: "rgb(155 126 172)" }}>
            Best regards, <span className="purple"><br/>ASIF ALAM</span>
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}
